import { RouteConfig } from './types';
import { lazy } from 'react';

// Lazy load components
const IVRDashboard = lazy(() => import('../pages/ivr/IVRDashboard'));
const IVRPhoneNumbers = lazy(() => import('../pages/ivr/IVRPhoneNumbers'));
const IVRMenus = lazy(() => import('../pages/ivr/IVRMenus'));
const IVRCallRouting = lazy(() => import('../pages/ivr/IVRCallRouting'));
const IVRMenuEditor = lazy(() => import('../pages/ivr/IVRMenuEditor'));
const IVRCallLogs = lazy(() => import('../pages/ivr/IVRCallLogs'));
const IVRErrorLogs = lazy(() => import('../pages/ivr/IVRErrorLogs'));
const IVRDebug = lazy(() => import('../pages/ivr/IVRDebug'));
const IVRLogSync = lazy(() => import('../pages/ivr/IVRLogSync'));
const IVRMockCalls = lazy(() => import('../pages/ivr/IVRMockCalls'));

export const ivrRoutes: RouteConfig[] = [
  { path: "/app/ivr", element: IVRDashboard, requiresLayout: true, requiredPermissions: ['ivr.read'] },
  { path: "/app/ivr/numbers", element: IVRPhoneNumbers, requiresLayout: true, requiredPermissions: ['ivr.read'] },
  { path: "/app/ivr/menus", element: IVRMenus, requiresLayout: true, requiredPermissions: ['ivr.read'] },
  { path: "/app/ivr/menus/:phone_number", element: IVRMenuEditor, requiresLayout: true, requiredPermissions: ['ivr.update'] },
  { path: "/app/ivr/menus/new", element: IVRMenuEditor, requiresLayout: true, requiredPermissions: ['ivr.create'] },
  { path: "/app/ivr/routing", element: IVRCallRouting, requiresLayout: true, requiredPermissions: ['ivr.read'] },
  { path: "/app/ivr/error-logs", element: IVRErrorLogs, requiresLayout: true, requiredPermissions: ['ivr.read'] },
  { path: "/app/ivr/call-logs", element: IVRCallLogs, requiresLayout: true, requiredPermissions: ['ivr.read'] },
  { path: "/app/ivr/log-sync", element: IVRLogSync, requiresLayout: true, requiredPermissions: ['ivr.read'] },
  { path: "/app/ivr/debug", element: IVRDebug, requiresLayout: true, requiredPermissions: ['ivr.read'] },
  { path: "/app/ivr/mock-calls", element: IVRMockCalls, requiresLayout: true, requiredPermissions: ['ivr.read'] }
];
